import { render, staticRenderFns } from "./Weed.vue?vue&type=template&id=473b5221&scoped=true&"
import script from "./Weed.vue?vue&type=script&lang=ts&"
export * from "./Weed.vue?vue&type=script&lang=ts&"
import style0 from "./Weed.vue?vue&type=style&index=0&id=473b5221&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b5221",
  null
  
)

export default component.exports